/* Roadhouse buttons (21.10.2026). Narrow pills: variant 8 "Lauftext". Wide pills (full-width buy buttons, checkout,
   "Alle Ergebnisse"): the "Leuchtreklame" fill – a second colour rises from below and the label changes colour; a
   ticker across a whole column looked lost there, and their inner label spans kept showing under it.
   Variant 8 "Lauftext": on hover the label starts to run through the pill like the
   board over the box office. Same typeface as the label, and the ticker starts exactly where the label sits, so the
   swap itself is invisible; it then speeds up gently. On leaving it fades back to the still label. The pill never
   changes. Only for devices with a real pointer and without "reduce motion" – phones get nothing extra.
   Leuchtreklame (rebuilt 27.10.2026): a copy of the label in the new colours lies over the pill, border included, and
   is uncovered from below. The label changes colour exactly where the fill has arrived – no delay to tune, and no
   thin rim of the old border showing around the fill. "Preis vorschlagen" and "Merken" in the buy column always rise.
   CSS in rh-skin.css (section 4h). */
(function () {
  if (!window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) return;
  var SELECTOR = '.button:not(.button--tertiary):not(.skip-to-content-link):not(.quantity__button):not(.cart-remove-button), .premium-search-submit, .rh-signup__button, .rh-demo__button, .rhw__button, .auction-button, .rh-wish--cta, .rh-offer__open, .rh-offer__submit';
  var ALWAYS_RISE = '.rh-offer__open, .rh-offer__submit, .product__info-container .rh-wish--cta';
  var SPEED = 60; // px per second once running
  var RAMP = 600; // ms to reach full speed
  var SEP = ' ✦ ';

  function label(btn) {
    var clone = btn.cloneNode(true);
    clone.querySelectorAll('.rh-ticker, .rh-rise-fill, .rh-arrow, .loading__spinner, .visually-hidden, svg').forEach(function (n) { n.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function prepare(btn) {
    var text = label(btn);
    if (!text || text.length > 40) return null;
    var tk = btn._rhTk;
    if (!tk) {
      var el = document.createElement('span');
      el.className = 'rh-ticker';
      el.setAttribute('aria-hidden', 'true');
      btn.appendChild(el);
      btn.classList.add('rh-tk');
      tk = btn._rhTk = { el: el, x: 0, raf: 0, text: '' };
    }
    // read the label colour only while it is visible (not while the ticker is running)
    if (!btn.classList.contains('rh-tk-on')) btn.style.setProperty('--rh-tk', getComputedStyle(btn).color);
    if (tk.text !== text || tk.width !== btn.clientWidth) {
      var el2 = tk.el;
      el2.style.paddingLeft = '0px';
      el2.textContent = text;
      var textW = el2.scrollWidth;
      el2.textContent = text + SEP;
      var unitW = el2.scrollWidth;
      var copies = Math.max(2, Math.ceil(btn.clientWidth / Math.max(unitW, 1)) + 1);
      el2.textContent = (text + SEP).repeat(copies * 2);
      // first copy sits exactly on the centred label
      el2.style.paddingLeft = Math.round((btn.clientWidth - textW) / 2) + 'px';
      tk.half = unitW * copies;
      tk.text = text;
      tk.width = btn.clientWidth;
    }
    return tk;
  }

  function enter(btn) {
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (btn._rhTk && btn.classList.contains('rh-tk-on') && btn._rhTk.running) return;
    var tk = prepare(btn);
    if (!tk) return;
    cancelAnimationFrame(tk.raf);
    clearTimeout(tk.reset);
    if (!btn.classList.contains('rh-tk-on')) tk.x = 0;
    tk.el.style.transform = 'translateX(' + tk.x + 'px)';
    btn.classList.add('rh-tk-on');
    tk.running = true;
    var start = performance.now();
    var last = start;
    (function step(now) {
      var dt = (now - last) / 1000;
      last = now;
      var p = Math.min(1, (now - start) / RAMP);
      var v = SPEED * p * p * (3 - 2 * p); // smooth start
      tk.x -= v * dt;
      if (-tk.x >= tk.half) tk.x += tk.half;
      tk.el.style.transform = 'translateX(' + tk.x.toFixed(2) + 'px)';
      tk.raf = requestAnimationFrame(step);
    })(start);
  }

  function leave(btn) {
    var tk = btn._rhTk;
    if (!tk) return;
    btn.classList.remove('rh-tk-on');
    tk.running = false;
    // keep it gliding while it fades, then park it
    tk.reset = setTimeout(function () {
      cancelAnimationFrame(tk.raf);
      tk.x = 0;
      tk.el.style.transform = 'translateX(0)';
    }, 350);
  }

  function isWide(btn) {
    var parent = btn.parentElement;
    return btn.clientWidth > 320 || (parent && btn.clientWidth >= parent.clientWidth * 0.85 && btn.clientWidth > 240);
  }

  function isLight(rgb) {
    var m = rgb.match(/\d+(\.\d+)?/g);
    if (!m) return false;
    return (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) > 150;
  }

  // Leuchtreklame: fill = the label colour, new label colour = the pill colour (outline pills: dark on light, gold on dark)
  function colours(btn) {
    // read the pill as it looks without the swap underneath (rh-skin.css: .rh-rise:hover takes the fill colours
    // once the fill is up, so Safari's tile seams show the same colour)
    btn.classList.add('rh-rise-off');
    var cs = getComputedStyle(btn);
    var text = cs.color;
    var bg = cs.backgroundColor;
    var opaque = bg && !/rgba\(.*,\s*0(\.0+)?\)$/.test(bg) && bg !== 'transparent';
    var bw = parseFloat(cs.borderTopWidth) || 0;
    btn.style.setProperty('--rh-rise-fill', text);
    btn.style.setProperty('--rh-rise-text', opaque ? bg : (isLight(text) ? '#0b0a09' : '#feae02'));
    btn.style.setProperty('--rh-rise-bw', bw + 'px');
    var box = { borderTopWidth: cs.borderTopWidth, paddingTop: cs.paddingTop, paddingRight: cs.paddingRight, paddingBottom: cs.paddingBottom,
      paddingLeft: cs.paddingLeft, display: cs.display, flexDirection: cs.flexDirection, justifyContent: cs.justifyContent, alignItems: cs.alignItems, gap: cs.gap };
    btn.classList.remove('rh-rise-off');
    return box;
  }

  // the copy sits exactly where the label sits: same padding (plus the border it covers), same flex layout
  function sync(btn) {
    var fill = btn._rhFill;
    var label = btn._rhLabel;
    var cs = colours(btn);
    var bw = parseFloat(cs.borderTopWidth) || 0;
    var st = label.style;
    // the label stands still at full height while the panel around it grows from below
    st.height = btn.getBoundingClientRect().height + 'px'; // border box = the fill, which covers the border
    st.paddingTop = (parseFloat(cs.paddingTop) + bw) + 'px';
    st.paddingRight = (parseFloat(cs.paddingRight) + bw) + 'px';
    st.paddingBottom = (parseFloat(cs.paddingBottom) + bw) + 'px';
    st.paddingLeft = (parseFloat(cs.paddingLeft) + bw) + 'px';
    var flex = /flex/.test(cs.display);
    st.flexDirection = flex ? cs.flexDirection : 'row';
    st.justifyContent = flex && cs.justifyContent !== 'normal' && cs.justifyContent !== 'flex-start' ? cs.justifyContent : 'center';
    st.alignItems = flex && cs.alignItems !== 'normal' ? cs.alignItems : 'center';
    st.gap = flex ? cs.gap : '0px';
    label.textContent = '';
    Array.prototype.forEach.call(btn.childNodes, function (n) {
      if (n === fill || (n.nodeType === 1 && n.matches('.rh-ticker, .loading__spinner, .visually-hidden'))) return;
      label.appendChild(n.cloneNode(true));
    });
    label.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
  }

  function rise(btn) {
    var fill = document.createElement('span');
    fill.className = 'rh-rise-fill';
    fill.setAttribute('aria-hidden', 'true');
    // Growing height, not clip-path or transform: zoomed in, Safari drew those on their own tiled layer and showed
    // hairline seams while the fill rose (27.10.2026). A plain height change is painted with the pill itself.
    var panel = fill.appendChild(document.createElement('span'));
    panel.className = 'rh-rise-panel';
    var label = panel.appendChild(document.createElement('span'));
    label.className = 'rh-rise-label';
    // Created on the first hover, while :hover already applies – a new element has no "before" state, so it would
    // appear risen at once. Hold it down inline (beats the hover rule), let the browser paint that, then release
    // it two frames later so the first hover rises like every other.
    panel.style.height = '0px';
    btn._rhFill = fill;
    btn._rhLabel = label;
    btn.appendChild(fill);
    btn.classList.add('rh-rise');
    sync(btn);
    void panel.offsetHeight;
    requestAnimationFrame(function () { requestAnimationFrame(function () { panel.style.height = ''; }); });
    btn.addEventListener('mouseenter', function () { sync(btn); });
    // labels change on click ("Merken" → "Gemerkt", "Wird gesendet …"): keep the copy in step
    new MutationObserver(function (records) {
      if (records.every(function (r) { return fill.contains(r.target) || r.target === fill || (r.type === 'attributes' && r.attributeName === 'style'); })) return;
      requestAnimationFrame(function () { sync(btn); });
    }).observe(btn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-disabled', 'disabled'] });
  }

  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest(SELECTOR);
    if (!btn || btn._rhBound) return;
    btn._rhBound = true;
    if (btn.matches(ALWAYS_RISE) || isWide(btn)) { rise(btn); return; }
    btn.addEventListener('mouseenter', function () { enter(btn); });
    btn.addEventListener('mouseleave', function () { leave(btn); });
    enter(btn);
  });
})();

/* Arrows in links and buttons ("Alles in Drums →", "Weiterlesen →") get their own span, so the shared hover can
   slide them (rh-skin.css section 15). Runs on load and again when a drawer or the search re-renders. */
(function () {
  var RE = /([→←↓↑])\s*$/;
  function wrap(root) {
    (root || document).querySelectorAll('a, button, summary').forEach(function (el) {
      if (el.querySelector('.rh-arrow') || el.closest('.rh-ticker')) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var node, last = null;
      while ((node = walker.nextNode())) { if (node.nodeValue.trim()) last = node; }
      if (!last || last.parentElement.closest('.rh-ticker')) return;
      var m = last.nodeValue.match(RE);
      if (!m) return;
      var span = document.createElement('span');
      span.className = 'rh-arrow' + ({ '←': ' rh-arrow--back', '↓': ' rh-arrow--down', '↑': ' rh-arrow--up' }[m[1]] || '');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = m[1];
      // the space before the arrow goes too, so the underline stops with the last word
      last.nodeValue = last.nodeValue.slice(0, m.index).replace(/[\s\u00a0]+$/, '');
      last.parentNode.insertBefore(span, last.nextSibling);
      // An underlined link carries its line onto every child, the arrow included (flex links even more so).
      // So the words move into their own span that takes the underline, and the link itself drops it.
      if (el.tagName === 'A' && span.parentNode === el) {
        var cs = getComputedStyle(el);
        if (cs.textDecorationLine.indexOf('underline') !== -1) {
          var label = document.createElement('span');
          label.className = 'rh-arrow-label';
          while (el.firstChild && el.firstChild !== span) label.appendChild(el.firstChild);
          el.insertBefore(label, span);
          label.style.textDecorationLine = 'underline';
          label.style.textDecorationStyle = cs.textDecorationStyle;
          label.style.textDecorationThickness = cs.textDecorationThickness;
          label.style.textUnderlineOffset = cs.textUnderlineOffset;
          el.classList.add('rh-arrow-host');
        }
      }
    });
  }
  function start() {
    wrap(document);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; wrap(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
